<template>
	<div class="operation-fraction-of-number">
		<div class="fraction-of-number-div">
			<fraction :fraction="fraction" />
			<span class="mx-1 operator">Of</span>
			<span class="number">{{ number }}</span>
			<span class="equal-sign">=</span>
			<fraction :fraction="fraction" :class="[{'divided-den': number % fraction.den == 0}]" />
			<span class="sign">x</span>
			<span class="number d-inline-block">
				<div class="division" v-if="number % fraction.den == 0">(<span class="division-number">{{ number / fraction.den }}</span>)</div>
				<div :title="number % fraction.den == 0 ? ` ${number}/${fraction.den} = ${number/fraction.den}` : ''" :class="[{'divided': number % fraction.den == 0}]">{{ number }}</div>
			</span>
			<span class="equal-sign">=</span>
			<span v-if="number % fraction.den != 0" class="multi-fraction">
				<fraction :fraction="result.extras[0]" />
				<equal-sign />
				<template v-if="!multiplied_fraction.isSimplificated || multiplied_fraction.intVal >= 1">
					<fraction :fraction="result" />
					<equal-sign />
					<template v-if="!multiplied_fraction.isSimplificated">
						<fraction :fraction="result.simplificated" class="result" />
						<equal-sign />
					</template>
				</template>
				<fraction :fraction="result" mixed />
			</span>
			<span v-else class="multi-operation">
				<fraction :fraction="{num: multi_operation, den: 1}" /><!--
				<span>{{ multi_operation }}</span> -->
				<equal-sign />
				<span class="result">{{ result.simplificated }}</span>
			</span>
		</div>
	</div>
</template>
<script type="text/javascript">
	import Fraction from '../scripts/Fraction';
	import FractionComponent from '../FractionComponent';
	import EqualSign from '../EqualSign';
	const $operations = require('../scripts/variables').operations;
	export default{
		name: 'operation-fraction-of-number',
		components: {FractionComponent, fraction: FractionComponent, EqualSign},
		props: {
			terms: {type: [Array], required: true, validator(val){
				let term = val.map(el => new Fraction(el).simplificated);
				return term.filterInt().length > 0;
			}},
		},
		data() {
			let fraction = this.terms.filter(term => (new Fraction(term)).simplificated != term).pop(),
				number = this.terms.filter(term => (new Fraction(term)).simplificated == term).pop();
			log('Data of calculation, fraction:', fraction, 'number:', number, 'terms:', this.terms);
			return{
				number: number,
				fraction: new Fraction(fraction),
				result: $operations.multiplicationFract(this.terms)
			};
		},
		created(){/*
			let terms = this.terms.map(el => new Fraction(el));
			if(terms[0].simplificated === Number(terms[0].num)){
				this.number = terms[0].num;
				this.fraction = this.terms[1];
			} else {
				this.number = terms[1].num;
				this.fraction = this.terms[0];
			}
			this.result = $operations.multiplicationFract(this.terms);*/
		},
		methods: {},
		computed: {
			multi_fraction() {
				return {num: this.fraction.num + " x " + this.number, den: this.fraction.den};
			},
			multiplied_fraction(){
				return new Fraction({num: this.fraction.num * this.number, den: this.fraction.den});
			},
			multi_operation(){
				return this.fraction.num + " x " + this.number / this.fraction.den;
			}
		}
	};
</script>
<style lang="scss">
	@import '../../styles/mixins';
	.operation-fraction-of-number {
		.fraction-of-number-div {
			.fraction-component {
				&.divided-den {
					.denominator-fraction {
						@include strikethrough(#e55);
					}
				}
			}
			.operator{}
			.number{
				.division {
					font-size: 0.9em;
					text-align: center;
					.division-number {
						color: #22e;
					}
				}
				.divided {
					@include strikethrough(#f00);
				}
			}
			.equal-sign{}
			.multi-fraction{}
			.multi-operation{}
		}
	}
</style> 